import React, { useCallback, useEffect } from 'react';
import { Container, useMediaQuery, useTheme } from '@mui/material';
import { AuditionListContainer } from '../../components/ScreenContainer/AuditionListContainer/AuditionListContainer';
import { useSelector } from 'react-redux';
import { auditionsSelector, filterSelector, selectedFiltersSelectors } from './selector';
import { useDispatch } from 'react-redux';
import { addFilter, filterAudition, getAllAuditions } from '../../redux/audition/actions';
import { MetaTags } from '../../components/Metatags/Metatags';
import { getFilters } from '../../redux/appConfigurator/action';
import { IAuditionFilter } from '../../redux/audition/types';

const parseFilter = (filters: IAuditionFilter) => {
    const parsed: Record<string, any> = {};
    Object.keys(filters).forEach(key => {
        const typedKey = key as keyof IAuditionFilter;
        const { value } = filters[typedKey];
        switch (typedKey) {
            case 'rehearsal_date_end':
            case 'rehearsal_date_start':
            case 'job_start_date':
            case 'job_end_date':
                parsed[key] = value;
                break;
            case 'talent_location':
            case 'shoot_location':
                if (typeof value === 'object' && 'coordinates' in value) {
                    parsed[key] = value.coordinates;
                }
                break;
            default:
                parsed[key] = filters[key as keyof IAuditionFilter].value;
                break;
        }
    });
    return parsed;
};

const Audition = () => {
    const { auditions, page, total, canLoadMore, limit, loading } = useSelector(auditionsSelector);
    const muiTheme = useTheme();
    const filters = useSelector(filterSelector);
    const selectedFilters = useSelector(selectedFiltersSelectors);
    const dispatch = useDispatch();
    const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm')); // Fullscreen on mobile

    const getAuditions = useCallback(() => {
        dispatch(getFilters({ coll_type: 'audition' }));
        dispatch(
            getAllAuditions({
                limit: 20,
                page: 1,
            }),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOnApply = (payload?: IAuditionFilter) => {
        if (payload) {
            const parsedPayload = parseFilter(payload);
            dispatch(addFilter(payload));
            dispatch(
                filterAudition({
                    ...parsedPayload,
                }),
            );
        }
    };

    const handleClearFilters = () => {
        dispatch(addFilter(undefined));
        dispatch(getAllAuditions(undefined));
    };

    const handleOnEndReach = () => {
        if (canLoadMore && !loading) {
            dispatch(
                getAllAuditions({
                    page: page + 1,
                    limit: limit,
                }),
            );
        }
    };

    useEffect(() => {
        getAuditions();
    }, [getAuditions]);
    return (
        <MetaTags title={`Thspian | Audme`} description={'All Auditions'}>
            <Container
                disableGutters={isMobile}
                sx={{
                    minWidth: '100%',
                    marginLeft: { xs: '0px', sm: '20px' },
                    marginTop: { xs: 2, sm: 0 },
                    overflowY: 'auto',
                }}>
                <AuditionListContainer
                    auditions={auditions}
                    filter={filters}
                    onApply={handleOnApply}
                    selectedFilters={selectedFilters}
                    deleteFilter={handleOnApply}
                    loading={loading}
                    onClearFilter={handleClearFilters}
                    onApplyClick={() => {}}
                    totalResults={total}
                    onCenterEndReached={handleOnEndReach}
                    onRightEndReached={() => {}}
                />
            </Container>
        </MetaTags>
    );
};

export { Audition };
